import DealLink from './DealLink';

export default DealLink;
